module.exports = __webpack_public_path__ + "img/poor.e8e72f96.svg";